export default "__VITE_ASSET__BYvbn8My__"